// extracted by mini-css-extract-plugin
module.exports = {"bg":"AboutUsPage__bg___2PSHH"};